var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Excel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "M15.07 10.607 5.582 8.932v12.375c0 .565.458 1.023 1.023 1.023h16.372c.565 0 1.023-.458 1.023-1.023v-4.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M15.07 0H6.605C6.04 0 5.582.458 5.582 1.023v4.56l9.488 5.582 5.023 1.675L24 11.165V5.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M5.582 5.583h9.488v5.582H5.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.372 4.466h-6.79v13.956h6.79a1.027 1.027 0 0 0 1.024-1.023V5.489a1.026 1.026 0 0 0-1.024-1.023",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.814 5.024H5.582v13.957h6.232a1.027 1.027 0 0 0 1.023-1.024V6.047a1.027 1.027 0 0 0-1.023-1.023",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.814 5.024H5.582v12.84h6.232a1.027 1.027 0 0 0 1.023-1.023V6.047a1.027 1.027 0 0 0-1.023-1.023",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.256 5.024H5.582v12.84h5.674a1.027 1.027 0 0 0 1.023-1.023V6.047a1.026 1.026 0 0 0-1.023-1.023",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Excel_svg__b)",
    d: "M1.023 5.024h10.233c.565 0 1.023.458 1.023 1.024v10.234c0 .566-.458 1.024-1.023 1.024H1.023A1.023 1.023 0 0 1 0 16.282V6.048c0-.566.458-1.024 1.023-1.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.168 14.491 2.153-3.335-1.972-3.318h1.586L6.011 9.96q.15.3.204.45h.014q.106-.241.224-.469l1.15-2.102h1.456l-2.022 3.298 2.073 3.354H7.561l-1.243-2.328a2 2 0 0 1-.148-.311H6.15a1.5 1.5 0 0 1-.144.301l-1.28 2.338z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M22.977 0H15.07v5.583H24v-4.56C24 .458 23.542 0 22.977 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M15.07 11.165H24v5.583h-8.93z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Excel_svg__b",
    x1: 2.133,
    x2: 10.148,
    y1: 4.225,
    y2: 18.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Excel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v22.33H0z"
  })))));
};
export default SvgExcel;